export var transformObject = function (object, _a) {
    var _b = _a.keys, keys = _b === void 0 ? function (key) { return key; } : _b, _c = _a.values, values = _c === void 0 ? function (value) { return value; } : _c;
    var result = {};
    for (var key in object) {
        result[keys(key)] = values(object[key]);
    }
    return result;
};
